import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import coverImageUrl from 'agency/digital_renderer/utils/coverImageUrl'

import ContentHolder from '../../ui/ContentHolder'

import headerImage from './assets/header.jpg'
import styles from './styles.scss'

const Header = (props) => {
  const {
    campaign: { address, suburb_name },
    campaignProposal,
    images,
    vendorName,
  } = props

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${coverImageUrl(campaignProposal.options, images, headerImage)})` }}
    >
      <div className={styles.overlay} />
      <ContentHolder>
        <Fade up>
          <h2 className={styles.address}>
            {address}, {suburb_name}
          </h2>

          <span className={styles.vendors}>{vendorName}</span>
        </Fade>
      </ContentHolder>
    </div>
  )
}

Header.propTypes = {
  campaign: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  images: PropTypes.object.isRequired,
  vendorName: PropTypes.string,
}

export default Header
